export enum SfEntityAutomationType {
	Workflows = 0x01,
	ValidationRules = 0x02,
	Flows = 0x04,
	ProcessBuilders = 0x08,
	ApexClasses = 0x10,
	FormulaFields = 0x20,
	ApexTriggers = 0x40,
	PageLayouts = 0x80,
	EmailTemplate = 0x100,
	EmailAlerts = 0x200,
	FieldUpdates = 0x400,
	AllProcessAutomations = Workflows | ValidationRules | Flows | ProcessBuilders | ApexClasses |
	FormulaFields | ApexTriggers | PageLayouts | EmailTemplate | EmailAlerts | FieldUpdates
}
